import * as yup from "yup";

export const DirectorshipSchema = yup.object().shape({
    name: yup.string().required().label("Name"),
    taxNo: yup.string().required().label("Tax Number"),
    regNo: yup.string().required().label("Registration Number"),
    isPublicCompany: yup.bool().required().label("Public Company")
});
